module.exports = __webpack_public_path__ + "img/56.c35f846a.png";